import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './app';
import './index.css';

console.log('[index.tsx] Rozpoczynam inicjalizację React');

// Ensure we're in browser environment before rendering
if (typeof window === 'undefined') {
  throw new Error('React DOM requires browser environment');
}

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root element not found');
}

console.log('[index.tsx] Root element znaleziony, tworzę root');

try {
  const root = ReactDOM.createRoot(rootElement);
  console.log('[index.tsx] React root utworzony');

  console.log('[index.tsx] Rozpoczynam renderowanie App');
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>
  );
  console.log('[index.tsx] Renderowanie zakończone');
} catch (error: any) {
  console.error('[index.tsx] BŁĄD podczas inicjalizacji React:', {
    message: error?.message,
    stack: error?.stack,
    name: error?.name
  });
  throw error;
} 